import Controller from '@ember/controller';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import type { FormationsIndexRouteModel } from './route';

export default class FormationsIndexController extends Controller {
  queryParams: readonly (string | Record<string, string>)[] = [
    'targetAudience',
    'families',
    'modality',
    'isNew',
    'planned',
    'parcours',
    'start',
    'end',
    'q',
    'page',
    'size',
  ];
  @tracked targetAudience: string = 'all';
  @tracked modality: string = 'all';
  @tracked planned: boolean | undefined = undefined;
  @tracked isNew: boolean = false;
  @tracked parcours: boolean = false;
  @tracked start: string | null = null;
  @tracked end: string | null = null;
  @tracked q: string | undefined;
  @tracked families: string[] = [];
  @tracked tags: string[] = [];
  @tracked page: number = 1;
  @tracked size: number = 12;

  get firstPage() {
    return 1;
  }

  get nextPage() {
    return this.page >= this.maxPage ? this.maxPage : this.page + 1;
  }

  get previousPage() {
    return this.page === 1 ? this.page : this.page - 1;
  }

  get maxPage() {
    return (this.model as FormationsIndexRouteModel).meta.lastPage;
  }

  @action
  updateTargetAudienceQP(value: string) {
    this.targetAudience = value;
    if (value === 'jobseeker') {
      this.parcours = true;
    } else {
      this.parcours = false;
    }
    this.page = 1;
  }
  @action
  updatePlannedQP(value: string) {
    if (value === 'planned') {
      this.planned = true;
    } else if (value === 'unplanned') {
      this.planned = false;
    } else {
      this.planned = undefined;
    }
    this.page = 1;
  }
  @action
  updateIsNewQP(value: boolean) {
    this.isNew = value;
    this.page = 1;
  }
  @action
  updateParcoursQP(value: boolean) {
    this.parcours = value;
    this.page = 1;
  }
  @action
  updateDateQP(value: string | null, key: 'start' | 'end') {
    if (key === 'start') {
      this.start = value;
    } else {
      this.end = value;
    }
    this.page = 1;
  }
  @action
  updateModalityQP(value: string) {
    this.modality = value;
    this.page = 1;
  }
  @action
  updateSearchQP(value: string | undefined) {
    this.q = value;
    this.page = 1;
  }
  @action
  updateFamiliesQP(value: string[]) {
    this.families = value;
    this.page = 1;
  }
  @action
  updateTagsQP(value: string[]) {
    this.tags = value;
    this.page = 1;
  }
}
